export const SPACE_LIST = 'user/spaceList';